import React from 'react'

const Presenter = () => {
  return (
    <div>Presenter</div>
  )
}

export default Presenter